// export const MenuList = [
//     //Dashboard
//     {
//         title:"Main Menu",
//         classsChange: "menu-title",
//         extraclass:"first",
        
//     },

    
//     //Dashboard
//     {
//         title: 'Dashboard',	
//         classsChange: 'mm-collapse',		
//         iconStyle: <i className="la la-home" />,
//         content: [
//             {
//                 title: 'Dashboard',
//                 to: 'dashboard',					
//             },
//             // {
//             //     title: 'Dashboard 2',
//             //     to: 'index-2',
//             // },
//             // {
//             //     title: 'Dashboard 3',
//             //     to: 'index-3',
//             // },
           
//         ],
//     },
    

//     //Management
//     {
//         title: 'Management',	        
//         to:"event-management",
//         iconStyle: <i className="la la-calendar" />,        
//     },
    


//     //Apps
//     {
//         title:"Order management",
//         classsChange: "menu-title",
//     },
//     {
//         title: 'Orders',	
//         classsChange: 'mm-collapse',
//         iconStyle: <i className="la la-users" />,
//         to: 'orders'
//     },

//     //CMS
//     {
//         title : "Order Refunds",
//         classsChange: 'mm-collapse',
//         // update:"New",
//         iconStyle: <i className="flaticon-381-database-1" />,
//         content:[
//             {
//                 title:'Content',
//                 to:'/content'
//             },
//             {
//                 title:'Menu',
//                 to:'/menu'
//             },
//             {
//                 title:'Email Template',
//                 to:'/email-template'
//             },
//             {
//                 title:'Blog',
//                 to:'/blog'
//             },
//             {
//                 title:'Add Content',
//                 to:'/content-add'
//             },
//             {
//                 title:'Add Email',
//                 to:'/add-email'
//             },
//             {
//                 title:'Add Blog',
//                 to:'/add-blog'
//             },
//             {
//                 title:'Blog Category',
//                 to:'/blog-category'
//             },
//         ],
//     },
//     //Charts
//     {
//         title: 'Dispatch Managment',	
//         classsChange: 'mm-collapse',
//         iconStyle: <i className="la la-signal" />,
//         content: [
            
//             {
//                 title: 'RechartJs',
//                 to: 'chart-rechart',					
//             },
//             {
//                 title: 'Chartjs',
//                 to: 'chart-chartjs',					
//             },
//             {
//                 title: 'Sparkline',
//                 to: 'chart-sparkline',					
//             },
//             {
//                 title: 'Apexchart',
//                 to: 'chart-apexchart',					
//             },
//         ]
//     },
//     {
//         title:"Restaurant management",
//         classsChange:"menu-title"
//     },

//     //Boosttrap
//     {
//         title: 'Zone Setup',	
//         classsChange: 'mm-collapse',
//         iconStyle: <i className="la la-globe"></i>,	
//         content: [
//             {
//                 title: 'Accordion',
//                 to: 'ui-accordion',					
//             },
//             {
//                 title: 'Alert',
//                 to: 'ui-alert',					
//             },
//             {
//                 title: 'Badge',
//                 to: 'ui-badge',					
//             },
//             {
//                 title: 'Button',
//                 to: 'ui-button',					
//             },
//             {
//                 title: 'Modal',
//                 to: 'ui-modal',					
//             },
//             {
//                 title: 'Button Group',
//                 to: 'ui-button-group',					
//             },
//             {
//                 title: 'List Group',
//                 to: 'ui-list-group',					
//             },
//             {
//                 title: 'Cards',
//                 to: 'ui-card',					
//             },
//             {
//                 title: 'Carousel',
//                 to: 'ui-carousel',					
//             },
//             {
//                 title: 'Dropdown',
//                 to: 'ui-dropdown',					
//             },
//             {
//                 title: 'Popover',
//                 to: 'ui-popover',					
//             },
//             {
//                 title: 'Progressbar',
//                 to: 'ui-progressbar',					
//             },
//             {
//                 title: 'Tab',
//                 to: 'ui-tab',					
//             },
//             {
//                 title: 'Typography',
//                 to: 'ui-typography',					
//             },
//             {
//                 title: 'Pagination',
//                 to: 'ui-pagination',					
//             },
//             {
//                 title: 'Grid',
//                 to: 'ui-grid',					
//             },
//         ]
//     },
//     //plugins
//     {
//         title:'Cuisine',
//         classsChange: 'mm-collapse',
//         iconStyle : <i className="la la-plus-square-o"></i>,
//         content : [
//             {
//                 title:'Select 2',
//                 to: 'uc-select2',
//             },
           
//             {
//                 title:'Sweet Alert',
//                 to: 'uc-sweetalert',
//             },
//             {
//                 title:'Toastr',
//                 to: 'uc-toastr',
//             },            
//             {
//                 title:'Light Gallery',
//                 to: 'uc-lightgallery',
//             },
//         ]
//     },
//     //Widget
//     {   
//         title:'Restaurants',
//         iconStyle: <i className="la la-desktop" />,
//         classsChange: 'mm-collapse',        
//         content : [
//             {
//                 title:'Add restaurant',
//                 to:'add-restaurant'
//             },
//             {
//                 title:'Restaurants List',
//                 to:'restaurants-list'
//             },
//             {
//                 title:'Widget List',
//                 to:'widget-list'
//             },
//         ]
//     },

   
    
// ]


export const MenuList = [
    {
        title:"Main Menu",
        classsChange: "menu-title",
        extraclass:"first",
    },
    //Dashboard
    {
        title: 'Dashboard',	
        to:"dashboard"
    },  
    
    {
        title: 'Dashboard',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="la la-home" />,
        content: [
            {
                title: 'Dashboard 1',
                to: 'dashboard',					
            },
           
        ],
    },
    
    {   
        title:'Users',
        iconStyle: <i className="flaticon-381-database-1" />,
        classsChange: 'mm-collapse',        
        content : [
            {title: "All Users", to: "all-user-list"},
            {title: "ICAI", to: "icai-user-list"},
            {title: "Non-ICAI", to: "non-icai-list"},
            {title: "Bulk Import", to: "bulk-import"}
        ]
    },

    {   
        title:'Employees',
        iconStyle: <i className="flaticon-381-database-1" />,
        classsChange: 'mm-collapse',        
        content : [
          {title: "Add new", to: "add-new-employee"},
          {title: "List", to: "employee/list"}
        ]
    },
]

